import { Paper } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import 'react-virtualized/styles.css';
import { completeSketch, getData, uploadSketch } from '../../services';
import ImageCarousel from '../ImageCarousel';
import SketchTool from '../SketchTool';
import { OrderReviewContext } from './OrderReviewContext';

function Sketch({ classes }) {
  const { state, dispatch } = useContext(OrderReviewContext);

  return (
    <Paper
      className={classes.sketchWrapper}
      style={{
        padding: 10,
        overflowY: 'auto',
      }}
    >
      <div style={{ flexShrink: 0 }}>
        <ImageCarousel
          images={state.formHeaders.reduce((prevFormHeader, currFormHeader) => {
            if (currFormHeader.images && currFormHeader.images.length) {
              return prevFormHeader.concat(
                currFormHeader.images.map(img => ({
                  ...img,
                  src: img.imageUri.replace('fieldrepimage', 'fieldrepimagelarge').replace('/raw/', '/large/'),
                })),
              );
            }
            return prevFormHeader;
          }, [])}
        />
      </div>
      <div style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <SketchTool
          orderFormHeaderId={
            state.formHeaders[state.activeFormHeaderIndex].formDefinitions.length
              ? state.formHeaders[state.activeFormHeaderIndex].formDefinitions[0].orderFormHeaderId
              : null
          }
          orderLineId={state.orderLineId}
          policyHolderLat={state.order?.policyHolderAddress?.latitude}
          policyHolderLng={state.order?.policyHolderAddress?.longitude}
          onSave={async (formAnswerSketchId, sketchImageBase64) => {
            try {
              const response = await uploadSketch(formAnswerSketchId, sketchImageBase64);
              const sketchUrl = await response.json();
              await completeSketch(formAnswerSketchId);
              const orderReviewData = await getData(state.orderLineId);

              dispatch({
                type: 'UPDATE_FORM_HEADERS',
                formHeaders: orderReviewData.formHeaders,
              });

              return sketchUrl;
            } catch (error) {
              console.log(error);
            }
          }}
        />
      </div>
    </Paper>
  );
}

const styles = theme => ({
  sketchWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
});
Sketch.propTypes = {};
export default withStyles(styles)(withRouter(Sketch));
